import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

interface AppInputSearchStyles {
  getGridsWidth: (width: number) => number,
  gridWidth: number
}
export const useStyles = makeStyles(() => createStyles({
  search: (props: AppInputSearchStyles) => ({
    width: `${props.getGridsWidth(props.gridWidth)}px`,
  }),
}));
